"use client";

// Development fallback
if (typeof window !== "undefined" && !window.zaraz) {
  window.zaraz = {
    track: (event, properties) => console.log("Zaraz track:", event, properties),
    set: (key, value) => console.log("Zaraz set:", key, value),
  };
}
